import { inject, Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ConfigurationService } from 'src/app/configuration/services/configuration.service';
import { GlobalNotificationPanelService } from 'src/app/shared/global-notification-panel/global-notification-panel.service';

@Injectable({
  providedIn: 'root'
})
export class TransportOutOverrideService {
  private router = inject(Router);
  private configurationService = inject(ConfigurationService);
  private globalNotificationPanelService = inject(GlobalNotificationPanelService);

  start(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationStart)
    ).subscribe(this.checkOverrideStatus);
  }

  checkOverrideStatus = async () => {
    const transportOutOverride = await this.configurationService.getEffectiveSettingValue('TransportOut_Override');
    const transportOutOverrideId = Number(transportOutOverride || 0);
    if (transportOutOverrideId > 0) {
      this.globalNotificationPanelService.showGlobalNotificationPanel('All outgoing locations are overridden', false);
    }
    else {
      this.globalNotificationPanelService.hideGlobalNotificationPanel();
    }
  }
}
